module.exports = __webpack_public_path__ + "static/media/wgr.bd1572e4.svg";